import { RecordType } from '@petconsole/pure-base';
import { vanRepairApiEntity } from '@petconsole/pure-fe-api';
import { VanRepairRecord } from '@petconsole/pure-shared';
import { sliceHookTypes } from '../../../helpers';
import {
  BaseSliceOptions,
  BaseSliceTab,
  CitySearchHooks,
  OurEntityHooks,
  RatingHooks,
  RequiredCrudSliverHooks,
  RequiredSliverHooks,
  TabValueHooks,
} from '../../../types';
import BaseEntitySlice from '../../base/BaseEntitySlice';

type ApiEntityRecord = VanRepairRecord;

const apiEntity = vanRepairApiEntity;
const { name: sliceName, plural } = apiEntity;
const vanRepair = sliceName;
const vanRepairs = plural;
const vanRepairAdmin = `${sliceName}Admin`;

const Tab = { vanRepairAdmin, vanRepair, vanRepairs } as const;
type Tabs = { [key in keyof typeof Tab]: BaseSliceTab };
type TabHooks = { [key in keyof typeof Tab]: TabValueHooks };
const tabs: Tabs = {
  vanRepairAdmin: { default: '' },
  vanRepair: { default: '' },
  vanRepairs: { default: 'Newest' },
};

const options: BaseSliceOptions<ApiEntityRecord> = {
  ...apiEntity,
  hasCitySliver: true,
  hasNewestSliver: true,
  hasCitySearch: true,
  hasDefaultProperties: true,
  hasRating: true,
  tabs,
};
const { hooks, reducer } = new BaseEntitySlice<ApiEntityRecord>({ options });
const { crudSliver, sliver, citySearch, property, rating, tabHooks } = sliceHookTypes;

export interface OurVanRepairHooks<T extends RecordType = ApiEntityRecord> extends OurEntityHooks<T> {
  vanRepairHooks: RequiredCrudSliverHooks;
  cityVanRepairHooks: RequiredSliverHooks;
  newestVanRepairHooks: RequiredSliverHooks;
  propertyHooks: RecordType;
  citySearchHooks: CitySearchHooks;
  ratingHooks: RatingHooks;
  tabHooks: TabHooks;
}

export const ourVanRepairHooks: OurVanRepairHooks = {
  entity: apiEntity,
  vanRepairHooks: crudSliver(apiEntity, hooks) as RequiredCrudSliverHooks,
  cityVanRepairHooks: sliver(apiEntity, 'City', hooks) as RequiredSliverHooks,
  newestVanRepairHooks: sliver(apiEntity, 'Newest', hooks) as RequiredSliverHooks,
  citySearchHooks: citySearch(apiEntity, hooks),
  propertyHooks: property(apiEntity, hooks),
  ratingHooks: rating(apiEntity, hooks),
  tabHooks: <TabHooks>tabHooks(Object.keys(Tab), hooks),
};

export default reducer;
